import { getSubscriptions, useSelectUserContext } from '@innovyze/stylovyze';
import { fullAccess } from '@innovyze/shared-utils';
import {
	getTenant,
	useSelectAssetLocation,
	useSelectAssetLocationIsWaiting,
} from '@innovyze/lib_am_common/Selectors';
import {
	selectRiskConfig,
	selectRunCompleteReload,
	selectRiskDetailsIsLoading,
	selectRiskDetailsIsWaiting,
	selectRiskDetailsTablePage,
	selectorRiskDetailsPagination,
	selectCanReload,
	selectRiskStore,
} from '@Selectors/Risk.selectors';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { AssetIdAndType } from '../RiskDetails.component';

export function useRiskDetailsSelectors() {
	const subscriptions = getSubscriptions();
	const hasFullAccess = fullAccess(subscriptions);

	const riskConfig = selectRiskConfig();

	const canReload = selectCanReload();
	const runCompleteReload = selectRunCompleteReload();

	const isLoading = selectRiskDetailsIsLoading();
	const isWaiting = selectRiskDetailsIsWaiting();
	const isRiskStoreLoading = selectRiskStore().isLoading;

	const tablePage = selectRiskDetailsTablePage();
	const tenantId = useSelector(getTenant);
	const { id: userId } = useSelectUserContext();
	const riskDetailsPagination = useSelector(selectorRiskDetailsPagination);

	const assetLocation = useSelectAssetLocation();
	const isWaitingAssetLocation = useSelectAssetLocationIsWaiting();

	const [findAsset, setFindAsset] = useState<AssetIdAndType | undefined>(
		undefined,
	);

	return {
		tablePage,
		hasFullAccess,
		isLoading,
		isWaiting,
		assetLocation,
		riskConfig,
		canReload,
		runCompleteReload,
		tenantId,
		userId,
		riskDetailsPagination,
		isWaitingAssetLocation,
		isRiskStoreLoading,
		findAsset,
		setFindAsset,
	};
}
